'use client';

import Banner from '../components/Banner';
import EventCarousel from '../components/EventCarousel';
import RecentNews from '../components/RecentNews';
import { ChevronRight } from 'lucide-react';
import CommentsSection from '../components/CommentsSection';
// import Image from 'next/image';
import RelatedCards from '../components/RelatedCards';
import Advertisement from '../components/Advertisement';
// import Bar from '../components/Bar';
import ReUsableSlider from '@/components/ReUsables/ReUsableSlider';
import { NewsBreakPoint } from '@/constants/home';
import VOHVideoPage from '../components/VOHVideoPage';
import ListenNow from '../components/ListenNow';
import { useState, useEffect } from 'react';
import TextWithDropCap from './TextWithDropCap';

function stripHtmlTags(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}

export default function UpdateOneUpPageComponent({
    update,
    updatesData,
    eventsData,
    updateCategoryData,
    commentData,
    vohTvData,
}: any) {
    if (!update || !Array.isArray(eventsData) || !Array.isArray(updatesData)) return <h1>Something went wrong...</h1>;
    // let categoryUpdates = [];
    if (Array.isArray(updatesData)) {
        // categoryUpdates =
        updatesData.filter((update) => update.editorialType.type === update.editorialType.type);
    }

    const [showListenNow, setShowListenNow] = useState(false);
    const toggleListenNow = () => {
        setShowListenNow(!showListenNow);
    };
    const closeListenNow = () => {
        setShowListenNow(false);
    };

    useEffect(() => {
        // Cleanup on page reload
        return () => {
            const synth = window.speechSynthesis;
            synth.cancel();
        };
    }, []);

    const headlineText = stripHtmlTags(update.headLine);
    const contentText = stripHtmlTags(update.para) + ' ' + stripHtmlTags(update.para_2);
    const combinedText = `${headlineText}. ${contentText}`;

    const hasAdData = process.env.NEXT_PUBLIC_ADSENSE_CLIENT_ID && process.env.NEXT_PUBLIC_ADSENSE_SLOT_ID;

    return (
        <div className="mt-2 mx-auto py-0">
            <div className="m-auto flex flex-col lg:flex-row ">
                {/* <Bar /> */}
                {/* Main article */}
                <div className="w-full lg:w-[70%]">
                    <div className="lg:col-span-2 w-full lg:w-[90%] mx-auto lg:ml-20">
                        <div className="">
                            <Banner update={update} onListenNowClick={toggleListenNow} />
                            <div className=" px-4 sm:px-2">
                                <div className="max-w-[100%] lg:max-w-[95%]">
                                    {/* <CkEditor_5 value={formattedPara} bgColor="white" /> */}
                                    {/* <div dangerouslySetInnerHTML={{ __html: formattedText }} /> */}
                                    <TextWithDropCap text={update.para} />
                                </div>

                                <div className="mt-10 relative overflow-y-auto border-t-[1px] border-solid border-[#222222] border-b-[1px]">
                                    <EventCarousel events={eventsData} />
                                </div>
                                <div className="max-w-[100%] lg:max-w-[95%] mt-4">
                                    {/* <div className="drop-cap"> */}
                                    {/* <CkEditor_5 value={update.para_2} bgColor="white" /> */}
                                    <TextWithDropCap text={update.para_2} />
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-6 w-full justify-start max-sm:grid max-sm:grid-cols-2 mt-12  px-4 sm:px-2 border-2">
                            {Array.isArray(update.tags) &&
                                update.tags[0]?.split(',').map((tag: string, idx: number) => {
                                    if (!tag || tag.trim().length === 0) return null;
                                    return (
                                        <p
                                            key={idx}
                                            style={{ border: '1px solid black' }}
                                            className="px-2 py-1 flex items-center hover:bg-gray-200 hover:border-gray-400 transition-transform duration-200 transform hover:scale-105 cursor-pointer"
                                        >
                                            {tag}
                                            <ChevronRight className="ml-2" />
                                        </p>
                                    );
                                })}
                        </div>

                        <CommentsSection commentData={commentData} editorialId={update.editorialId} />
                    </div>
                </div>
                {/* sidebar */}
                <div className="w-full lg:w-[30%] py-4 px-2 lg:px-0">
                    <h2
                        className="mb-4 font-medium leading-tight font-serif text-xl lg:text-2xl border-l-4 border-solid border-[#059AFF] pl-2"
                        style={{
                            fontFamily: 'Inter',
                            fontWeight: '400',
                            fontSize: '23.25px',
                            lineHeight: '26.4px',
                            letterSpacing: '-1.2px',
                        }}
                    >
                        Recent News
                    </h2>
                    <div className="flex flex-col gap-4 lg:gap-6 mb-5">
                        {/* <div className="px-1 flex flex-col gap-y-2"> */}
                        {Array.isArray(updatesData) &&
                            updatesData.slice(0, 6).map((item: any, idx: number) => {
                                return <RecentNews update={item} key={idx} />;
                            })}
                        {/* </div> */}
                    </div>
                    {hasAdData && <Advertisement />}

                    {showListenNow && <ListenNow text={combinedText} onClose={closeListenNow} />}
                </div>
            </div>

            <div className="py-0 lg:pt-10 lg:pb-10 w-full lg:w-[100%] px-2 lg:px-20 mx-auto">
                <h2
                    className="mb-2"
                    style={{ fontFamily: 'PT Serif', fontWeight: '700', fontSize: '41.42px', lineHeight: '52.8px' }}
                >
                    Must Read
                </h2>
                <ReUsableSlider slideNumber={1} autoPlay gap={20} breakpoints={NewsBreakPoint} loading>
                    {Array.isArray(updateCategoryData) &&
                        updateCategoryData.slice(0, 10).map((update, idx) => {
                            return <RelatedCards data={update} key={idx} />;
                        })}
                </ReUsableSlider>
            </div>
            <VOHVideoPage vohTvData={vohTvData} />
        </div>
    );
}
